export default __webpack_public_path__ + "static/media/icon-price.71dd9aeb.svg";